import { useEffect, useState } from "react";
import MultiLiveDialog from "./multiLiveDialog";
import MultiLiveIcon from "./multiLiveIcon";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setClearPopoversSlice, setMultiLivesPopovers } from "redux-share/slices/popoversSlice";
import { API, apiCaller } from "../../../../../services";
import { setMultiLives } from "redux-share/slices/videoDataSlice";
import { conditions, multiLiveVideo, responseValidator } from "helpers";
import { ConditionName } from "interfaces";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const MultiLive = () => {
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const { alternative_Lives, multiLives } = useAppSelector(
        ({ videoData: { alternative_Lives, multiLives } }) => ({ alternative_Lives, multiLives }),
        shallowEqual
    );
    const { multiLivesPopover } = useAppSelector(({ popovers: { multiLivesPopover } }) => ({ multiLivesPopover }), shallowEqual);

    const handleShowMultiLives = async () => {
        dispatch(setClearPopoversSlice());
        dispatch(setMultiLivesPopovers(true));
        const { data, status } = await apiCaller({ url: API().live.multiLives, method: "POST", data: { user_ids: [...alternative_Lives] } });
        if (responseValidator(status)) dispatch(setMultiLives(data));
    };

    useEffect(() => {
        if (!conditions(ConditionName.showMultiLivePopover) && multiLives.length > 0 && multiLiveVideo()) {
            const video = multiLiveVideo();
            video.pause();
            video.removeAttribute("src");
            video.load();
        }
    }, [multiLivesPopover]);

    return (
        <div className="pl-relative pl-flex pl-items-center">
            <MultiLiveIcon
                onClick={handleShowMultiLives}
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
            />
            {showTooltip && <ControllbarTooltip title="پخش زنده های دیگر (q)" className="pl-right-[-35px]" />}
            <MultiLiveDialog status={conditions(ConditionName.showMultiLivePopover)} onClose={() => dispatch(setMultiLivesPopovers(false))} />
        </div>
    );
};

export default MultiLive;
